import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { WsService } from 'src/app/modules/core/services/websocket.service';
// import { NgxUiLoaderService } from 'ngx-ui-loader';
// import { SimulationFeedbackService } from 'src/app/modules/simulation-started/services';

import { SimulationService } from 'src/app/modules/simulation/services';
import { ToastSuccessfullyComponent } from '../../toast/toast-successfully.component';
import { SIMULATION_EVENT } from '../../types';

@Component({
    selector: 'public-feedback-dialog-app',
    templateUrl: 'public-feedback-dialog.component.html',
    styleUrls: ['./public-feedback-dialog.component.scss'],
})
export class PublicFeedBackDialogComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PublicFeedBackDialogComponent>,
        public simulationService: SimulationService,
        public router: Router,
        private wsService: WsService,
        private ngxService: NgxUiLoaderService,
        private _snackBar: MatSnackBar,
    ) {}
    ngOnInit(): void {
        const participantStore = localStorage.getItem('participant');
        const participant = participantStore ? JSON.parse(participantStore) : null;
        this.wsService.connect(this.router.url.split('=')[1], participant.participantId);
    }
    onClickPublickFeedback() {
        let raw = {
            simulationId: this.data.id,
            actionType: 'PUBLISH',
            detailsRequest: {
                name: this.data.name,
                startDate: this.data.startDate,
                startTime: this.data.startTime,
                organizationId: this.data.organizationId,
                simulationTypeId: this.data.simulationTypeId,
                roomNumber: this.data.roomNumber,
                participantLogAvailable: this.data.participantLogAvailable,
            },
            settingsRequest: {
                loginCode: this.data.loginCode,
                link: this.data.link,
                acceptJoinViaLink: this.data.acceptJoinViaLink,
                allowJoinAfterSimulationStarts: !!this.data.allowJoinAfterSimulationStarts,
                startVideoRecording: this.data.startVideoRecording,
                invitePeople: JSON.parse(this.data.invitePeople),
            },
        };

        if (this.data.id) {
            this.ngxService.start();
            this.simulationService.update(raw).subscribe(
                (res: any) => {
                    if (Boolean(res.status)) {
                        this.dialogRef.close('success');
                        this._snackBar.openFromComponent(ToastSuccessfullyComponent, {
                            duration: 3000,
                            horizontalPosition: 'center',
                            verticalPosition: 'top',
                            panelClass: ['successfully-snackbar', 'd-flex', 'align-items-center'],
                            data: {
                                status: 'successfully',
                                text: 'Publish Feedback Successfully!',
                            },
                        });
                        const msg = {
                            event: SIMULATION_EVENT.PUBLISH
                        }
                        this.wsService.messages.next(JSON.stringify({ data: JSON.stringify(msg) }));
                        this.wsService.messages.error({
                            code: 4000,
                            reason: 'Some thing went wrong. Please contact customer service to support!',
                        });
                    }
                },
                () => {
                    this.dialogRef.close('error');
                },
                () => {
                    this.ngxService.stop();
                },
            );
        }
    }
    onClose() {
        this.dialogRef.close();
    }
}
